<template>
  <div>
    <SysDialogFullScreen
      v-model="DILAOG_ATIVO"
      @click:hidden-dialog="fecharDialog()"
      titulo="Comparativo de produtos"
    >
      <sys-data-table
        :headers="headers"
        :items="desserts"
        :height="ALTURA_TABELA_PRODUTOS"
        :item-height="50"
        class="elevation-1"
        :item-class="classesCssLinha"
      >
        <template #top>
          <div class="d-flex align-center w-full py-2 px-1">
            <div class="font-16 font-weight-medium text-gray-900">
              Produto: {{ PRODUTO_SELECIONADO_MENU_CONTEXTO.idproduto + ' - ' + PRODUTO_SELECIONADO_MENU_CONTEXTO.descricao_produto }}
            </div>

            <v-spacer />

            <div class="w-400">
              <SysProdutoAutoComplete
                v-model="produtos_comparar"
                dense
                outlined
                hide-details
                multiple
                height="10"
                class="barra-de-rolagem-filtros-status-produtos"
                placeholder="Selecione os produtos a comparar"
                :ignorar_produtos="desserts"
              />
            </div>

            <v-btn class="ml-3" color="primary" @click="compararProdutos()">
              Comparar
            </v-btn>
          </div>
        </template>

        <template #item.descricao_produto="{ item }">
          {{ `${item.idproduto} - ${item.descricao_produto}` }}
        </template>

        <template #item.preco_compra="{ item }">
          <span>
            {{ Helpers.formatarValorMonetario(item.preco_compra) }}
          </span>
        </template>

        <template #item.custo_unitario="{ item }">
          <span
            :class="{
              'cor-vermelha-tabela-comparacao' : item.max_preco_custo,
              'cor-verde-tabela-comparacao' : item.min_preco_custo,
            }"
          >
            {{ Helpers.formatarValorMonetario(item.custo_unitario) }}
          </span>
        </template>

        <template #item.preco_medio_venda="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

        <template #item.estoque="{ item }">
          <span
            :class="{
              'cor-vermelha-tabela-comparacao' : item.min_estoque,
              'cor-verde-tabela-comparacao' : item.max_estoque,
            }"
          >
            {{ Helpers.formatarValor(item.estoque) }}
          </span>
        </template>

        <template #item.estoque_seguranca="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.ponto_pedido="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.estoque_maximo="{ value }">{{ Helpers.formatarValor(value) }}</template>

        <template #item.consumo_medio_mensal="{ item }">
          <span
            :class="{
              'cor-vermelha-tabela-comparacao' : item.min_consumo_medio_mensal,
              'cor-verde-tabela-comparacao' : item.max_consumo_medio_mensal,
            }"
          >
            {{ Helpers.formatarValor(item.consumo_medio_mensal) }}
          </span>
        </template>

        <template #item.desvio_padrao_consumo="{ value }">{{ Helpers.formatarValor(value) }}</template>

        <template #item.actions="{ item }">
          <v-btn icon @click="removerProdutoComparacao(item)">
            <v-icon v-if="String(item.idproduto) === String(item.produto_pai)" v-text="'mdi-delete-off'" color="#9F9F9F" />
            <v-icon v-else v-text="'mdi-delete'" />
          </v-btn>
        </template>
      </sys-data-table>
    </SysDialogFullScreen>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { buscarProdutoSelecionado, compararProdutos, removerProdutoComparacao } from './CompararProdutosApi'
import Responsividade from '@/helpers/ResponsiveHeight'
import SysProdutoAutoComplete from '@/components/utils/crud/SysProdutoAutocomplete';
import SysDialogFullScreen from '@/components/padraoDeLayout/SysDialogFullScreen.vue';
import SysBotao from '../../../utils/botoes/SysBotao.vue';

export default {
  mixins: [Responsividade],
  components: { SysDialogFullScreen, SysProdutoAutoComplete, SysBotao },
  model: {
    prop: 'dialog_comparar_produtos',
    event: 'change:dialog_comparar_produtos'
  },
  props: {
    dialog_comparar_produtos: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      produtos_comparar: [],
      headers: [
        { text: 'Descrição do produto', value: 'descricao_produto' },
        { text: 'Descrição da marca', value: 'marca' },
        { text: 'Status Produto', value: 'status_produto' },
        { text: 'Preço compra', value: 'preco_compra' },
        { text: 'Preço custo', value: 'custo_unitario' },
        { text: 'Preço médio venda', value: 'preco_medio_venda' },
        { text: 'Estoque', value: 'estoque' },
        { text: 'Estoque segurança', value: 'estoque_seguranca' },
        { text: 'Ponto pedido', value: 'ponto_pedido' },
        { text: 'Estoque máximo', value: 'estoque_maximo' },
        { text: 'Projeção de vendas', value: 'consumo_medio_mensal' },
        { text: 'Desvio parão consumo', value: 'desvio_padrao_consumo' },
        { text: 'Ações', value: 'actions' },
      ],
      desserts: []
    }
  },
  computed: {
    ...mapGetters({
      PRODUTO_SELECIONADO_MENU_CONTEXTO: "tabelaProduto/GET_PRODUTO_SELECIONADO_MENU_CONTEXTO",
      GRUPO_COMPRAS: "usuario/getGrupoCompras",
      FILIAL_COMPRAS: "usuario/getFilialCompras"
    }),
    DILAOG_ATIVO: {
      get() { return this.dialog_comparar_produtos },
      set() { this.fecharDialog() }
    },
    ALTURA_TABELA_PRODUTOS() {
      return parseInt(this.alturaDaJanela - 165);
    }
  },
  watch: {
    DILAOG_ATIVO(valor) {
      this.desserts = [];
      if (valor) this.buscarProdutoSelecionado();
    },
    desserts() {
      this.produtos_comparar = [];
    }
  },
  methods: {
    fecharDialog() {
      this.produtos_comparar = [];
      this.$emit('change:dialog_comparar_produtos', false);
    },
    buscarProdutoSelecionado() {
      const paramentros = {
        id_grupo: this.GRUPO_COMPRAS,
        filial: this.FILIAL_COMPRAS,
        item_pai: this.PRODUTO_SELECIONADO_MENU_CONTEXTO.idproduto,
        comparar: this.produtos_comparar
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarProdutoSelecionado(paramentros)
          .then(i => this.desserts = i)
          .catch(() => this.Helpers.logout())
      )
    },
    compararProdutos() {
      const paramentros = {
        id_grupo: this.GRUPO_COMPRAS,
        filial: this.FILIAL_COMPRAS,
        item_pai: this.PRODUTO_SELECIONADO_MENU_CONTEXTO.idproduto,
        comparar: this.produtos_comparar
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        compararProdutos(paramentros)
          .then(i => this.desserts = i)
          .catch(() => this.Helpers.logout())
      )
    },
    removerProdutoComparacao(item) {
      if (String(item.idproduto) === String(item.produto_pai)) return;

      const paramentros = {
        id_grupo: this.GRUPO_COMPRAS,
        filial: this.FILIAL_COMPRAS,
        item_pai: this.PRODUTO_SELECIONADO_MENU_CONTEXTO.idproduto,
        delete: item
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        removerProdutoComparacao(paramentros)
          .then(i => this.desserts = i)
          .catch(() => this.Helpers.logout())
      )
    },
    classesCssLinha(linha) {
      return {
        'font-weight-medium': String(linha.idproduto) === String(linha.produto_pai)
      };
    }
  }
}
</script>

<style scoped>
.cor-vermelha-tabela-comparacao {
  color: red;
}
.cor-verde-tabela-comparacao {
  color: green;
}
</style>
